module.exports = __webpack_public_path__ + "media/videos/workout_preview-e1a8c2050fd72961a3a14c9ef393ec21.mp4";